import { LoadingStates } from "../Util/loadingStates";

export const REVIEW_RESPONSE_PENDING = "REVIEW_RESPONSE_PENDING";
export const REVIEW_RESPONSE_SUCCESS = "REVIEW_RESPONSE_SUCCESS";
export const REVIEW_RESPONSE_ERROR = "REVIEW_RESPONSE_ERROR";
export const CLEAR_REVIEW_INITIATE = "CLEAR_REVIEW_INITIATE";

const initialState = {
  status: LoadingStates.IDLE,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REVIEW_RESPONSE_PENDING:
      return { ...state, status: LoadingStates.PENDING, error: null };
    case REVIEW_RESPONSE_SUCCESS:
      return { ...state, status: LoadingStates.FINISHED, error: null };
    case REVIEW_RESPONSE_ERROR:
      return { ...state, status: LoadingStates.ERROR, error: action.error };
    case CLEAR_REVIEW_INITIATE:
      return initialState;
    default:
      return state;
  }
};

const storeName = "reviewInitiate";
const storeMapping = { [storeName]: reducer };
export const reviewInitiateSelector = (state) => state[storeName];
export default storeMapping; 
